// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"K0-z"};